module.exports = new __parcel__URL__("nist-lam--dataset-cover.2118f7e0.png").toString();